import React, { useEffect } from "react";
import UpdatesData from "./components/UpdatesData";
import { useDispatch } from "react-redux";
import { getUpdatesAction } from "../../redux/actions/updatesActions";
import { useParams, useSearchParams } from "react-router-dom";
import { UPDATES_ALL_ACTION_TYPE } from "../../redux/actions-type";

const UpdatesPage = () => {
  const dispatch = useDispatch();
  const { id, modelName } = useParams();
  const [searchParams] = useSearchParams();

  const groupId = searchParams.get("groupId");

  useEffect(() => {
    if (id) {
      dispatch(getUpdatesAction(id, modelName, groupId));
    }

    return () => {
      dispatch({ type: UPDATES_ALL_ACTION_TYPE.RESET_UPDATES });
    };
  }, [id]);
  return (
    <div className="details-page ">
      <UpdatesData />
    </div>
  );
};

export default UpdatesPage;
